// Define a type for CSS styles
import React, { useEffect } from "react";

import { TimeString, timeStrings } from "./react.time.filter";
import { DisplayFilterProps } from "@me8eon/filters/src/filters.plugin";
import { useTranslation } from "@me8eon/translation";
import { useAttributeEditorComponents } from "@me8eon/editors";
import { EonUiDropdown, EonUiDropdownOption } from "@eon-ui/eon-ui-components-react";
import { EonUiDropdownCustomEvent } from "@eon-ui/eon-ui-components";

//Later we change this to eon component
export function TimeDisplay({ filterOps, rootId }: DisplayFilterProps<TimeString | undefined>) {
    const translate = useTranslation();
    const [filterValue, setFilterValue] = filterOps;
    return (
        <EonUiDropdown
            onValueChanged={(e: EonUiDropdownCustomEvent<string>) => {
                setFilterValue(e.target.value as TimeString);
            }}
            value={filterValue}
            key={rootId}
            name="time_range"
            size="normal"
            label={translate(`filterPage.filterMenu.timeRange`)}
            showSelectedItems={true}
        >
            {timeStrings.map((time, index) => (
                <EonUiDropdownOption key={index} value={time} label={translate(`filterPage.timeRangeOptions.${time}`)} />
            ))}
        </EonUiDropdown>
    )
}